export default "__VITE_ASSET__B17peaS6__"